import { SessionExtra } from "../../store/Session/SessionModel";
import SkeletonLineWrapper from "../SkeletonWrapper/SkeletonLineWrapper";
import ShotDispersionChart from "./ShotDispersionChart";

interface Props {
  sessionData: SessionExtra;
}

const ShotDispersionChartWrap = ({ sessionData }: Props): JSX.Element => {
  return (
    <div className="dispersion-chart">
      <div className="text-wrapper-dispersion">Dispersion</div>
      <div className="golf-range-chart-container">
        <SkeletonLineWrapper height="600px">
          <ShotDispersionChart sessionData={sessionData} />
        </SkeletonLineWrapper>
      </div>
    </div>
  );
};
export default ShotDispersionChartWrap;
